<template>
    <section>
        <div class="filter-services__wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <filter-category
                            :items="categories"
                            :categories="categories"
                            :category="categorySelected"
                            v-if="categories"
                            @filterById="filterById">
                        </filter-category>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="loading">
            <div class="row">
                <div class="col-12 justify-content-center d-flex flex-wrap py-5">
                    <img :src="imageloading" alt="cargando">
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div
                class="row global__pb-75"
                v-match-heights="{
                    el: ['.card-service__title h3', '.card-service__text']
                }"
                v-if="cardNow"
            >
                <div class="col-12 mb-4">
                    <p class="text-uppercase"
                        v-if="cardNow.length">
                        Revisa {{cardNow.length > 1 ? 'los' : 'el'}} {{cardNow.length > 1 ? cardNow.length : ''}} estudio{{ cardNow.length > 1 ? 's' : ''}} disponible{{ cardNow.length > 1 ? 's' : ''}}
                    </p>
                    <p class="text-uppercase"
                        v-else>
                        No hay resultados disponibles
                    </p>
                </div>
                <div class="col-12 col-md-6 col-lg-4"
                    v-for="(card, index) in cardNow"
                    :key="index">
                    <card-service :item="card"></card-service>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import FilterCategory from './FilterCategory.vue';
import CardService from './CardService.vue';
export default {
    name: 'Services',
    components: {
        FilterCategory,
        CardService,
    },
    props:{
        imageloading: {
            type: String,
            default: '',
        },
        lang: String
    },
    data(){
        return {
            categories: [],
            loading: false,
            total: 0,
            categorySelected: 0,
            cards: [],
        }
    },
    mounted(){
      this.getCategories();
    },
    computed: {
        cardNow(){
            return this.cards;
        },
    },
    methods: {
        async getCategories(){
            const url = `${window.location.origin}/estudios/category?lang=${this.lang}`;
            const getData = await fetch(url);
            const data = await getData.json();
            this.categories = data;
            this.filterById(this.categories[0].id);
        },
        async filterById(id){
            this.loading = true;
            this.categorySelected = id;
            const url = `${window.location.origin}/estudios/category/?cat=${id}&lang=${this.lang}`;
            const getData = await fetch(url);
            const data = await getData.json();
            this.cards = data;
            this.loading = false;
        },
    }
}
</script>
